angular.module('businessThread')
    .controller('BusinessThreadTimelineController', function ($uibModalInstance, $state, BusinessThread, BusinessThreadService, BusinessThreadLinkFlagService, BusinessThreadTimelineUi, data) {
        this.thread = data || {}
        this.items = []
        this.filteredItems = []
        this.resourceTypes = []
        this.resourceTypeCounts = {}
        this.flags = BusinessThreadLinkFlagService.flags
        this.filters = {
            search: null,
            resourceType: null,
            dateFrom: null,
            dateTo: null,
            flags: [],
            showConfidential: false
        }
        this.activeFilters = false
        this.showResourceTypeFilter = true
        this.loading = false

        this.load = () => {
            if (!this.thread || !this.thread.id) {
                return
            }

            this.loading = true
            return BusinessThread.timeline({
                id: this.thread.id,
                includeConfidential: this.filters.showConfidential === true
            }).$promise.then(items => {
                this.items = items || []
                this.resourceTypes = BusinessThreadTimelineUi.resourceTypes(this.items)
                this.resourceTypeCounts = BusinessThreadTimelineUi.resourceTypeCounts(this.items)
                this.applyFilters()
            }).finally(() => this.loading = false)
        }
        this.applyFilters = () => {
            this.activeFilters = BusinessThreadTimelineUi.hasActiveFilters(this.filters)
            this.filteredItems = BusinessThreadTimelineUi.filter(this.items, this.filters)
        }
        this.clearFilters = () => {
            this.filters = {
                search: null,
                resourceType: null,
                dateFrom: null,
                dateTo: null,
                flags: [],
                showConfidential: false
            }
            this.load()
        }
        this.resourceLabel = BusinessThreadTimelineUi.resourceLabel
        this.resourceIcon = BusinessThreadTimelineUi.resourceIcon
        this.resourceTypeCount = type => this.resourceTypeCounts[type] || 0
        this.timelineEmptyText = () => 'Brak powiązanych rekordów'
        this.threadHref = () => BusinessThreadTimelineUi.threadHref(this.thread)
        this.openThread = event => {
            if (event && (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)) {
                return
            }
            if (event) {
                event.preventDefault()
            }
            $uibModalInstance.dismiss('thread-open')
            $state.go('businessThreadShowFull', {id: this.thread.id})
        }
        this.onResourceClick = event => {
            if (event && (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)) {
                return
            }
            $uibModalInstance.dismiss('resource-open')
        }
        this.unlinkResource = item => {
            let unlink = BusinessThreadService.unlinkResource(item)
            return unlink && unlink.then ? unlink.then(() => this.load()).catch(angular.noop) : unlink
        }
        this.flagResource = (item, flag) => {
            let toggle = BusinessThreadLinkFlagService.toggleFlag(item, flag)
            return toggle && toggle.then ? toggle.then(() => this.load()).catch(angular.noop) : toggle
        }
        this.cancel = () => $uibModalInstance.dismiss('cancel')
        this.load()
    })
